import { render } from "./TransactionListModal.vue?vue&type=template&id=1b157b54&ts=true"
import script from "./TransactionListModal.vue?vue&type=script&lang=ts"
export * from "./TransactionListModal.vue?vue&type=script&lang=ts"

import "./TransactionListModal.vue?vue&type=style&index=0&id=1b157b54&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__